import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Container } from './Container';
export const EditorialHeader = ({ eyebrow, title, intro, backTo, backLabel, children }) => (_jsx(PageHeader, { children: _jsxs(Container, { children: [backTo && (_jsxs(BackLink, { to: backTo, children: [_jsx(ArrowLeft, { size: 17, "aria-hidden": "true" }), backLabel] })), _jsx(Overline, { children: eyebrow }), _jsx(InteriorTitle, { children: title }), intro && _jsx(HeaderLead, { children: intro }), children && _jsx(HeaderActions, { children: children })] }) }));
export const PageSection = styled.section `
  padding-block: clamp(3rem, 5.5vw, 5.5rem);
`;
export const Overline = styled.p `
  margin: 0 0 1.25rem;
  color: ${({ theme }) => theme.colors.navy900};
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  line-height: 1.6;
`;
export const InteriorTitle = styled.h1 `
  max-width: 920px;
  margin: 0;
  color: ${({ theme }) => theme.colors.navy900};
  font-size: clamp(2rem, 4vw, 3.5rem);
  font-weight: 400;
  letter-spacing: -0.055em;
  line-height: 1.1;
  overflow-wrap: break-word;
  text-wrap: pretty;
`;
export const SectionTitle = styled.h2 `
  margin: 0;
  color: ${({ theme }) => theme.colors.navy900};
  font-size: clamp(1.75rem, 2.6vw, 2.5rem);
  font-weight: 400;
  letter-spacing: -0.045em;
  line-height: 1.15;
  text-wrap: pretty;
`;
export const BodyText = styled.p `
  max-width: 70ch;
  margin: 1.25rem 0 0;
  color: ${({ theme }) => theme.colors.muted};
  font-size: 1.0625rem;
  line-height: 1.75;
  overflow-wrap: break-word;
`;
export const TextLink = styled(Link) `
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  gap: 0.75rem;
  color: ${({ theme }) => theme.colors.navy900};
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.5;
  svg {
    flex-shrink: 0;
  }
  &:hover {
    text-decoration: underline;
    text-underline-offset: 5px;
  }
`;
export const InlineNotice = styled.div `
  border-left: 2px solid ${({ theme }) => theme.colors.blue600};
  padding: 0.7rem 0 0.7rem 1rem;
  color: ${({ theme }) => theme.colors.muted};
  font-size: 0.875rem;
  line-height: 1.65;
  p {
    margin: 0;
  }
  strong {
    display: block;
    color: ${({ theme }) => theme.colors.navy900};
    margin-bottom: 0.25rem;
  }
`;
export const AnchorLink = styled.a `
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  gap: 1rem;
  color: ${({ theme }) => theme.colors.navy900};
  font-size: 0.9375rem;
  line-height: 1.5;
  &:hover {
    text-decoration: underline;
    text-underline-offset: 5px;
  }
  svg {
    flex-shrink: 0;
  }
`;
const PageHeader = styled.header `
  padding-block: clamp(2rem, 4.5vw, 4.5rem);
  background: ${({ theme }) => theme.colors.surface};
  > div {
    position: relative;
    border-bottom: 1px solid ${({ theme }) => theme.colors.line};
    padding-bottom: 2.5rem;
  }
  > div::after {
    content: '';
    position: absolute;
    bottom: -1px;
    right: 0;
    width: 24px;
    height: 9px;
    border-bottom: 2px solid ${({ theme }) => theme.colors.navy900};
    border-right: 2px solid ${({ theme }) => theme.colors.navy900};
  }
`;
const HeaderLead = styled(BodyText) `
  max-width: 760px;
  margin-top: 1.5rem;
`;
const HeaderActions = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem 2rem;
  margin-top: 1.75rem;
`;
const BackLink = styled(TextLink) `
  font-size: 0.8125rem;
  font-weight: 400;
  margin-bottom: 1.5rem;
`;
